import utils from 'utils';

import {useState, useEffect, useMemo} from 'react';

import {useLabel} from '@/hooks/export';
import {UiCheckbox} from '@components/export';

export const FilterListItem = (props: {
    filter: any,
    handle: any,
    initShowOptions?: boolean,
    hideQty?: boolean,
    collapsable?: boolean,
}) => {
    const label = useLabel();

    // fixme: to config
    const defaultLimit = 6;
    const maxLimit = 1000;

    // todo: add red circle near filter with active checkboxes

    const [displayLimit, setDisplayLimit] = useState(defaultLimit);
    const [showOptions, setShowOptions] = useState(!!props.initShowOptions);

    // todo: filter for values applied locally
    // todo: show active option at the top - already
    // todo: if only 1 option available, dont show filter

    const data = {
        filterList: props.filter.list.filter((value) => {
            return !(!value.qty && !props.hideQty && !value.checked);
        }),
    };

    // fixme: set deps for correct visibility
    const flags = {
        isInitMany: useMemo(() => props.filter.list.length > defaultLimit, []),
        isMany: data.filterList.length > defaultLimit,
        isEmpty: !data.filterList.length,
        inFilters: data.filterList.some((value) => value.checked),
    };

    const handle = {
        toggleShowMore() {
            setDisplayLimit(displayLimit === defaultLimit ? maxLimit : defaultLimit);
        },
        searchFilter(value: string, name: string) {
            props.handle.searchFilter(value, name);

            setDisplayLimit(defaultLimit);
        },
    };

    useEffect(() => {
        setShowOptions(props.initShowOptions);
    }, [props.initShowOptions]);

    return <div className={classMap.item}>
        {
            props.collapsable ?
                <div
                    className={classMap.title}
                    onClick={() => setShowOptions(!showOptions)}
                >
                    <span>{props.filter.label}</span>
                    <i className={
                        'iconfas-circle ' + classMap.statusIcon +
                        (flags.isEmpty ? ' ' + classMap.statusIconDisabled : '') +
                        (flags.inFilters ? ' ' + classMap.statusIconActive : '')

                    }></i>
                    <i className={
                        showOptions ?
                            'iconfa-arrowUp' :
                            'iconfa-arrowDown'
                    }></i>
                </div> :
                <></>
        }
        <div className={classMap.box + (!showOptions ? ' ' + classMap.boxHidden : '')}>
            {
                flags.isInitMany ?
                    <div className={classMap.search}>
                        <i className={classMap.iconSearch}></i>
                        <input
                            type="text"
                            placeholder={label.doSearch + '...'}
                            onChange={(e) => handle.searchFilter(e.target.value, props.filter.name)}
                        />
                    </div> :
                    <></>
            }
            <div className={classMap.content}>
                {
                    data.filterList
                        .map((value: any, index: number) => {
                        if (index < displayLimit) {
                            return <div className={classMap.option} key={index}>
                                <UiCheckbox
                                    onChange={
                                        (checked) => props.handle.selectFilter(checked, props.filter.name, value.name)
                                    }
                                    disabled={!value.qty && !props.hideQty && !value.checked}
                                    label={
                                        <>
                                            {value.label}
                                            {(!props.hideQty ? (' ' + `(${value.qty})`) : '')}
                                        </>
                                    }
                                    checked={value.checked}
                                />
                            </div>;
                        }
                    })
                }
            </div>

            {
                data.filterList.length > defaultLimit ?
                    <div
                        onClick={() => handle.toggleShowMore()}
                        className={classMap.moreOption}
                    >
                        {
                            displayLimit > defaultLimit ?
                                <span><i className={'iconfa-arrowUp'}></i> {label.showLess}</span> :
                                <span><i className={'iconfa-arrowDown'}></i> {label.showMore}</span>
                        }
                    </div> :
                    <></>
            }
        </div>
    </div>;
};

const cmpClass = 'filter-list-item';
const classMap = utils.generateClassMap(cmpClass, {
    box: 'box',
    boxHidden: 'box--hidden',
    item: 'item',
    title: 'title',
    content: 'content',
    option: 'option',
    moreOption: 'more-option',
    input: 'input',
    search: 'search',
    statusIcon: 'status-icon',
    statusIconActive: 'status-icon--active',
    statusIconDisabled: 'status-icon--disabled',
    status: 'status',
    iconSearch: 'icon-search iconfa-search',
});
